import {
  SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
  SET_DECISION_JUDGEMENT_IDS,
  SET_CLAIM_HISTORY_ACTIONS,
  SET_CLAIM_HISTORY_SAGIS,
  SET_INSTRUCTIONS,
  REQUEST_RESET_HISTORY_STORE,
  SET_PENDING_TASKS_CLAIM,
  SET_CLAIM_CIVIL_PARTY,
  SET_DECISION_FLOW_VICTIMS,
} from 'containers/CourtManagerLegalProceedings/constants';
import { fromJS } from 'immutable';

const initState = fromJS({
  checkCivilPartyJudiciaryProcess: {},
  decisionJudgementIds: {},
  claimHistoryActions: [],
  claimHistorySagis: [],
  instructions: [],
  pendingTasksClaim: [],
  claimCivilParty: {},
  decisionFlowVictim: {},
});

const ManagerLegalProceedingsReducer = (state = initState, action: any) => {
  switch (action.type) {
    case SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS:
      return state.set(
        'checkCivilPartyJudiciaryProcess',
        fromJS(action.payload),
      );
    case SET_DECISION_JUDGEMENT_IDS:
      return state.set('decisionJudgementIds', fromJS(action.payload));
    case SET_CLAIM_HISTORY_ACTIONS:
      return state.set('claimHistoryActions', fromJS(action.payload));
    case SET_CLAIM_HISTORY_SAGIS:
      return state.set('claimHistorySagis', fromJS(action.payload));
    case SET_INSTRUCTIONS:
      return state.set('instructions', fromJS(action.payload));
    case SET_PENDING_TASKS_CLAIM:
      return state.set('pendingTasksClaim', fromJS(action.payload));
    case SET_CLAIM_CIVIL_PARTY:
      return state.set('claimCivilParty', fromJS(action.payload));
    case SET_DECISION_FLOW_VICTIMS:
      return state.set('decisionFlowVictim', fromJS(action.payload));
    case REQUEST_RESET_HISTORY_STORE:
      return state
        .set('claimHistoryActions', fromJS([]))
        .set('claimHistorySagis', fromJS([]));
    default:
      return state;
  }
};
export default ManagerLegalProceedingsReducer;
